<template>
  <div class="error-page">
    <div class="error-page__glow error-page__glow--1" />
    <div class="error-page__glow error-page__glow--2" />

    <span class="error-page__watermark">403</span>

    <router-link to="/" class="error-page__logo-wrap">
      <img src="./../assets/Intelligential-logo-texto-blanco.png" class="error-page__logo" />
    </router-link>

    <div class="error-page__body">
      <p class="error-page__eyebrow">Error 403</p>
      <h1 class="error-page__title">No tienes acceso a este módulo</h1>
      <p class="error-page__desc">
        Si consideras que deberías tenerlo, contacta a nuestro equipo de soporte en
        <a href="mailto:soporte@intelligential.tech">soporte@intelligential.tech</a>.
      </p>
      <div class="error-page__actions">
        <button class="error-page__btn-primary" @click="returnPrevView">
          <i class="fas fa-arrow-left" /> Regresar
        </button>
        <router-link class="error-page__btn-ghost" to="/">
          Ir al inicio
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  methods: {
    ...mapActions(['returnPrevView'])
  }
}
</script>

<style lang="scss" scoped>
.error-page__desc a {
  color: #4c70ff;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
}
</style>
